DJ.addBehavior('conseils-adaptes--filters', '.conseils-adaptes--filters', {
  attach: function(context, settings, behavior) {
    once('toggle-open', '.conseils-adaptes--filters > .form-item').forEach(el => {
      el.addEventListener('click', function(e) {
        const isOpen = el.classList.contains('open');

        document.querySelector('.conseils-adaptes--filters > .form-item.open')?.classList.remove('open');

        if (isOpen) {
          el.classList.remove('open');
        } else {
          el.classList.add('open');
        }
      });
    });
  },

  detach: function(context, settings) {}
});

DJ.addBehavior('conseils-adaptes-form', '.conseils-adaptes-form', {
  attach: function(context, settings, behavior) {
    document.querySelectorAll('.conseils-adaptes-form').forEach(form => {
      const defaultLegend = {
        emotions: 'Vos émotions',
        effetsSecondaires: 'Vos effets secondaires',
      };

      function updateCount() {
        // Récupérer la valeur du radio sélectionné
        const emotions = [...form.querySelectorAll('input[name^="emotions"]:checked')].map(cb => cb.value);

        if (emotions.length) {
          form.querySelector('[data-drupal-selector="edit-emotions"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="emotions"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">' + [...form.querySelectorAll('input[name^="emotions"]:checked + .option')].length + '</span>';
        } else {
          form.querySelector('[data-drupal-selector="edit-emotions"] .fieldset-legend').innerHTML = defaultLegend.emotions;
        }

        // Récupérer les effets secondaires
        const effetsSecondaires = [...form.querySelectorAll('input[name^="effets_secondaires"]:checked')].map(cb => cb.value);

        if (effetsSecondaires.length) {
          form.querySelector('[data-drupal-selector="edit-effets-secondaires"] .fieldset-legend').innerHTML = '<span class="items">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].map(cb => cb.innerHTML).join(', ') + '</span><span class="count">' + [...form.querySelectorAll('input[name^="effets_secondaires"]:checked + .option')].length + '</span>';
        } else {
          form.querySelector('[data-drupal-selector="edit-effets-secondaires"] .fieldset-legend').innerHTML = defaultLegend.effetsSecondaires;
        }
      }

      updateCount();
      form.addEventListener('change', updateCount);

      form.addEventListener('reset', function() {
        form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(input => {
          input.removeAttribute('checked');
          input.checked = false;

          // 🔥 Trigger change event
          const event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        });
      })
    });
  },

  detach: function(context, settings) {}
});
